import { DEFAULT_PLAYER_ID, GAME_LEVEL_IDS, SAVED_PLAYER_DATA_ID, SAVED_PLAYER_DATA_PREFIX } from 'app/constants/AppConstants';
import { zeroPad } from 'utils/utils';
import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';
import CharacterIntro from '../states/CharacterIntro';

/**
 */

export default class GameModel {
  constructor({ settings, gameData: data }) {
    this.settings = settings;
    this.data = { ...data };
    /**
     * parse data
     */
    this.id = DEFAULT_PLAYER_ID;
    this.forceInstructions = true;
    this.tutorialComplete = false;

    this.warningComplete = false;

    this.selectedCharacter = '';
    this.isCharacterAvailable = true;
    this.level = 1;
    this.reset();
    this.init();
  }

  init() {
    this.saveSlots = this.loadSlotsData();
    if (!this.saveSlots) {
      this.initSaveSlots();
    }

    const savedData = this.loadSimpleSave(this.id);
    if (!savedData) {
      this.createNewSaveSlot(this.id);
      this.savePlayerData(this.id, this.serialize());
    } else {
      this.deserialize(savedData);
    }
  }

  reset() {
    this.level = 1;
    this.currentLevelScores = [];
  }

  /**
   * Used to toggle first play forced Instructions
   */
  setInstructionsViewed() {
    this.forceInstructions = false;
    this.savePlayerData(this.id, this.serialize());
  }

  /**
   * Used to toggle help off after first play
   */
  setTutorialIsComplete() {
    this.tutorialComplete = true;
    this.savePlayerData(this.id, this.serialize());
  }

  setChosenCharacter(selectedCharacter) {
    switch (selectedCharacter) {
      case CharacterIntro.SELECTED_APPLE:
        this.selectedCharacter = 'apple';
        break;
      case CharacterIntro.SELECTED_ONION:
        this.selectedCharacter = 'onion';
        break;
      default:
        console.log('CHARACTER SELECTED IS INVALID');
    }
  }

  getChosenCharacter() {
    return this.selectedCharacter;
  }

  getCurrentLevelTimeResults() {
    return { current: this.levelTimes[this.level - 1], best: this.bestLevelTimes[this.level - 1] };
  }
  getCurrentLevel() {
    return this.level;
  }
  getCurrentLevelID() {
    return GAME_LEVEL_IDS[this.level - 1];
  }
  getGameIsComplete() {
    return this.level === GAME_LEVEL_IDS.length;
  }
  getIsTutorialMode() {
    return !this.tutorialComplete;
  }
  getGameScore() {
    return this.currentLevelScores.reduce((i, score) => {
      return i + score;
    }, 0);
  }
  getBestScore() {
    return this.bestGameScore;
  }

  levelUp() {
    this.level++;
    return this.level;
  }

  saveLevelScore(level, score) {
    this.currentLevelScores[level - 1] = score;
    this.bestLevelScores[level - 1] = Math.max(this.bestLevelScores[level - 1], score);
    this.savePlayerData(this.id, this.serialize());
  }

  saveGameScore(score) {
    this.bestGameScore = Math.max(this.bestGameScore, score);
    this.savePlayerData(this.id, this.serialize());
  }

  saveLevelTime(time) {
    const currentBest = this.bestLevelTimes[this.level - 1] || time;
    const isBest = time < currentBest;
    const bestLevelTime = Math.min(time, currentBest);
    this.bestLevelTimes[this.level - 1] = bestLevelTime;
    this.levelTimes[this.level - 1] = time;
    this.savePlayerData(this.id, this.serialize());
    return isBest;
  }

  /*
  ====================================================================================================
    DATA SERIALIZATION
  ====================================================================================================
  */

  deserialize(data) {
    const json = JSON.parse(data);
    for (let i in json) {
      if (this[i] != null || this[i] != undefined) {
        this[i] = json[i];
      }
    }
  }

  serialize() {
    let data = {
      id: this.id,
      forceInstructions: this.forceInstructions,
      bestLevelTimes: this.bestLevelTimes,
      tutorialComplete: this.tutorialComplete,
    };
    return JSON.stringify(data);
  }

  /*
  ====================================================================================================
    S A V E S
  ====================================================================================================
  */
  initSaveSlots() {
    // create save slots if it doesn't exist
    let dataSlots = this.loadSlotsData();
    if (!dataSlots) {
      let data = { slots: [] };
      let dataString = JSON.stringify(data);
      this.settings.setGameData(SAVED_PLAYER_DATA_ID, dataString);
    }
  }

  loadSlotsData() {
    /*jshint sub:true*/
    let dataString = this.settings.getAllSettings().gameData[SAVED_PLAYER_DATA_ID];
    if (dataString) {
      return JSON.parse(dataString);
    }
    return false;
  }

  createNewSaveSlot(saveId) {
    //read slots data
    let dataSlots = this.loadSlotsData();

    //add to existing slots
    dataSlots.slots.push(saveId);

    //save updated data
    let dataString = JSON.stringify(dataSlots);
    this.settings.setGameData(SAVED_PLAYER_DATA_ID, dataString);
  }

  deleteSaveSlot(saveId) {
    //read slots data
    let dataSlots = this.loadSlotsData();

    //remove slot
    let ind = dataSlots.slots.indexOf(saveId);
    dataSlots.slots.splice(ind, 1);

    //save updated data
    let dataString = JSON.stringify(dataSlots);
    this.settings.setGameData(SAVED_PLAYER_DATA_ID, dataString);

    //remove game save
    this.settings.setGameData(SAVED_PLAYER_DATA_PREFIX + saveId, null);
  }

  savePlayerData(saveId, data) {
    this.settings.setGameData(SAVED_PLAYER_DATA_PREFIX + saveId, data);
  }

  loadSimpleSave(saveId) {
    let dataString = this.settings.getAllSettings().gameData[SAVED_PLAYER_DATA_PREFIX + saveId];
    return dataString;
  }
}
